import {useQuery, gql} from '@apollo/client'

const eventDetailsQuery = gql`
  query GetEventDetails {
    eventDetails {
      EVENT_ID
      EVENT_NAME
      USER_EMAIL
      IS_ACTIVE
      HAS_RECORDING
    }
  }
`

export const useGetEventDetails = () => {
  return useQuery(eventDetailsQuery, {
    context: {clientName: 'adminPanel'},
    notifyOnNetworkStatusChange: true
  })
}
